import { lazily } from 'react-lazily'

/**
 * Layouts
 */
import { SingleAction } from 'layout'

const { Error404 } = lazily(() => import('pages/errors'))

/**
 * Layouts
 */
const LAYOUTS = {
  singleAction: SingleAction,
}

const basePath = '/'

const errorRoutes = [
  {
    name: 'error404',
    path: 'eeror-recurso-no-encontrado',
    element: Error404,
    suspenseFallback: null,
  },
]

export default errorRoutes